const encode = (val) => {
  const convert = (v) => encodeURIComponent(btoa(String(v)))
  return val instanceof Array ? val.map(convert) : convert(val)
}

const decode = (code) => {
  const convert = (v) => atob(decodeURIComponent(v))
  return code instanceof Array ? code.map(convert) : convert(code)
}

export const urlEncHelper = (plainUrlString) => {
  try {
    const encSearchParams = (search) => {
      const copy = new URLSearchParams()
      for (const [key, value] of search) {
        copy.append(encode(key), encode(value))
      }
      return copy
    }

    const url = new URL(plainUrlString, 'https://www.example.com')
    url.pathname = encode(url.pathname.substring(1))
    url.search = encSearchParams(url.searchParams).toString()
    const returnUrl = url.pathname + url.search
    return returnUrl
  } catch (error) {
    return 'error-url'
  }
}

export const urlDecHelper = (encUrlString) => {
  try {
    const decSearchParams = (search) => {
      const copy = new URLSearchParams()
      for (const [key, value] of search) {
        copy.append(decode(key), decode(value))
      }
      return copy
    }

    const url = new URL(encUrlString, 'https://www.example.com')
    url.pathname = decode(url.pathname.substring(1))
    url.search = decSearchParams(url.searchParams).toString()
    const returnUrl = url.pathname + url.search
    return returnUrl
  } catch (error) {
    return 'error-url'
  }
}

export const queryEncHelper = (query) => {
  return Object.entries(query).reduce((acc, cur) => ({ ...acc, [encode(cur[0])]: encode(cur[1]) }), {})
}

export const queryDecHelper = (query) => {
  return Object.entries(query).reduce((acc, cur) => ({ ...acc, [decode(cur[0])]: decode(cur[1]) }), {})
}
